import React, { cloneElement } from 'react';
import clsx from 'clsx';
import { displayName as BaseButtonName } from '../BaseButton';
import { useStyles } from './styles';
const sanityCheck = (children) => {
    if (React.Children.toArray(children).some(child => !child.type ||
        typeof child.type === 'string' ||
        child.type.displayName !== BaseButtonName)) {
        throw new Error('[BaseButtonGroup] BaseButtonGroup only accepts BaseButtons(s) as its children.');
    }
};
const BaseButtonGroup = ({ children }) => {
    const ownClasses = useStyles();
    sanityCheck(children);
    return (React.createElement("div", { className: ownClasses.root }, React.Children.toArray(children).map(child => {
        const Label = child;
        return cloneElement(Label, {
            classes: {
                ...Label.props.classes,
                root: clsx(ownClasses.buttonRoot, Label.props.classes?.root),
            },
        });
    })));
};
export default BaseButtonGroup;
